import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../../../store/actions';
import TableUtilidadesPorMarca from '../../Utilidades/TablesUtilidades/TableUtilidadesPorMarca';
import BarUtilidadesChartBase from './BarUtilidadesChartBase';

const BarUtilidadesPorMarca = (props) => {
  useEffect(() => {
    if (!props.estaCargado && props.ejecucionDePagina) {
      props.onLoadChart(props.mes, props.anio);
    }
  }, [props.ejecucionDePagina]);

  return (
    <BarUtilidadesChartBase
      title={'Utilidad por marca'}
      utilidadPor="marca"
      total={props.total}
      utilidades={props.utilidades}
      categories={props.utilidades}
      categoriasCompletas={props.utilidades.filter((util) => util.estaOculto === false)}
      loading={props.loading}
      chartSinDatos={props.utilidades.length === 0}
      utilidadTable={<TableUtilidadesPorMarca />}
      onChangeUtilOcultas={(utilidades) => props.onChangeUtilidadesOcultas(utilidades)}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    utilidades: state.ventas.utilidadPorMarca.utilidades,
    total: state.ventas.utilidadPorMarca.total,
    loading: state.ventas.utilidadPorMarca.loading,
    error: state.ventas.utilidadPorMarca.error,
    estaCargado: state.ventas.utilidadPorMarca.estaCargado,
    mes: state.ventas.fechaVentasDelMes.mes,
    anio: state.ventas.fechaVentasDelMes.anio,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onLoadChart: (mes, anio) => dispatch(actions.loadUtilidadPorMarca(mes, anio)),
    onChangeUtilidadesOcultas: (utilidades) => dispatch(actions.updateUtilidadesPorMarcaOcultos(utilidades))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BarUtilidadesPorMarca);
